import { TableColumn } from '@shared/interfaces';
import { Hosts } from '../interface';

/**
 * The columns for the hosts table.
 */
export const HOSTS_COLUMNS: TableColumn[] = [
    { field: 'hostName', header: 'Host Name', width: '220px', hasRedirect: true },
    { field: 'dealerName', header: 'Dealer Name', width: '180px', hasRedirect: true },
    { field: 'address', header: 'Address', width: '180px' },
    { field: 'city', header: 'City', width: '140px' },
    { field: 'state', header: 'State', width: '80px' },
    { field: 'postalCode', header: 'Postal Code', width: '120px' },
    { field: 'timezone', header: 'Timezone', width: '130px' },
    { field: 'programmaticId', header: 'Programmatic Id', width: '200px' },
    { field: 'totalLicenses', header: 'Total Licenses', width: '130px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '120px',
        type: 'actions',
        actions: [
            { icon: 'pencil-edit', name: 'edit', color: '#8DCB2C' },
            { icon: 'delete', name: 'delete', color: '#E73535 ' },
        ],
    },
];
